// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class FixedPricingProduct {
  readonly id: string;
  readonly name: string;
  readonly plantId: string;
  readonly plantName: string;
  readonly amount: string;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.plantName = data.plantName === undefined ? '' : data.plantName;
    this.amount = data.amount === undefined ? '0' : data.amount;
  }

  static zero(): FixedPricingProduct {
    const zeroValues: ExcludeMethodsDeep<FixedPricingProduct> = {
      id: NIL_UUID,
      name: '',
      plantId: NIL_UUID,
      plantName: '',
      amount: '0',
    };
    return new FixedPricingProduct(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type FixedPricingProductWireFormat = {
  id: string;
  name: string;
  plantId: string;
  plantName: string;
  amount: string;
};

type NewFixedPricingProductProps = PartialDeep<FixedPricingProduct, { recurseIntoArrays: true }>;
export const NewFixedPricingProduct: (props: NewFixedPricingProductProps) => FixedPricingProduct = (
  props,
) => new FixedPricingProduct(props);

type NewFixedPricingProductFromWireFormatProps = PartialDeep<
  FixedPricingProductWireFormat,
  { recurseIntoArrays: true }
>;
export const NewFixedPricingProductFromWireFormat: (
  props: NewFixedPricingProductFromWireFormatProps,
) => FixedPricingProduct = (props) => new FixedPricingProduct(props);
